<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-flag`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 5a1 1 0 01.846 1.532L35.64 18l7.205 11.468A1 1 0 0141.999 31l-31.916.001v9.957a2.042 2.042 0 11-4.083 0V7a2 2 0 012-2h34zm-5.56 4H10.084v18h26.358l-5.615-9 5.615-9zM22 13a1 1 0 011 1v2a1 1 0 01-1 1h-6a1 1 0 01-1-1v-2a1 1 0 011-1h6z"/></svg>
</template>
<script>

export default {
  name: 'IconFlag',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
